import { render, staticRenderFns } from "./UploaderHome.vue?vue&type=template&id=7b57b260&"
import script from "./UploaderHome.vue?vue&type=script&lang=ts&"
export * from "./UploaderHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports